import classNames from "classnames";
import {
  CopyIcon,
  ThumbsUpIcon,
  CheckIcon,
  ThumbsDownIcon,
} from "../../common/unhealthie/fancyIcons";
import { useState } from "react";
import Button from "../../common/unhealthie/Button";
import toast from "react-hot-toast";

interface props {
  onCopy: () => void;
  onThumbsUp: () => void;
  onThumbsDown: () => void;
}

const HoverMenu = ({ onCopy, onThumbsUp, onThumbsDown }: props) => {
  const [showCopiedTextIcon, setShowCopiedTextIcon] = useState(false);
  const [showClickedThumbsUpIcon, setShowClickedThumbsUpIcon] = useState(false);
  const [showClickedThumbsDownIcon, setShowClickedThumbsDownIcon] =
    useState(false);

  const onCopyClick = () => {
    onCopy();
    toast.success("Text copied!");
    setShowCopiedTextIcon(true);
    setTimeout(() => {
      setShowCopiedTextIcon(false);
    }, 5000);
  };

  const onThumbsUpClick = () => {
    onThumbsUp();
    setShowClickedThumbsUpIcon(true);
    setShowClickedThumbsDownIcon(false);
    toast.success("Thank you for your feedback!");
  };

  const onThumbsDownClick = () => {
    onThumbsDown();
    setShowClickedThumbsDownIcon(true);
    setShowClickedThumbsUpIcon(false);
    toast.success("Thank you for your feedback!");
  };

  return (
    <div className={styles.container}>
      <Button
        id="research-assistant-copy-button"
        className={styles.button}
        type="ghostOld"
        onClick={onCopyClick}
        Icon={showCopiedTextIcon ? CheckIcon : CopyIcon}
        iconClassName={styles.icon}
      />
      <Button
        id="research-assistant-thumbs-up-button"
        className={styles.button}
        type="ghostOld"
        onClick={onThumbsUpClick}
        Icon={showClickedThumbsUpIcon ? CheckIcon : ThumbsUpIcon}
        iconClassName={styles.icon}
      />
      <Button
        id="research-assistant-thumbs-down-button"
        className={styles.button}
        type="ghostOld"
        onClick={onThumbsDownClick}
        Icon={showClickedThumbsDownIcon ? CheckIcon : ThumbsDownIcon}
        iconClassName={styles.icon}
      />
    </div>
  );
};

const styles = {
  container: classNames(
    "tw-flex",
    "tw-flex-row",
    "tw-gap-2",
    "tw-items-center",
    "tw-justify-content",
  ),
  button: classNames("tw-size-8", "tw-p-1"),
  icon: classNames("tw-size-4", "tw-cursor-pointer"),
};

export default HoverMenu;
